module.exports = __webpack_public_path__ + "img/bg-courtship-online.e6338e0.png";